var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSerbia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_34095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37262 0 0 5.37262 0 12C0 13.4678 0.264047 14.874 0.746391 16.1739H23.2537C23.736 14.874 24 13.4678 24 12C24 5.37262 18.6274 0 12 0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 0C6.84013 0 2.44161 3.2565 0.746094 7.82611H23.2534C21.5578 3.2565 17.1593 0 11.9997 0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10254 6.78265V12.7689C3.10254 16.1741 7.55102 17.2175 7.55102 17.2175C7.55102 17.2175 11.9995 16.1741 11.9995 12.7689V6.78265H3.10254Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94238 7.82613H10.1598V5.73916L9.11632 6.26088L7.55112 4.69568L5.98587 6.26088L4.94238 5.73916V7.82613Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 13.6024L7.56514 10.2111L4.17383 13.6024L5.28059 14.7091L7.56514 12.4246L9.84969 14.7091L10.9565 13.6024Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 10.4348H9.37414C9.46311 10.2812 9.51486 10.1034 9.51486 9.91317C9.51486 9.3368 9.04766 8.86969 8.47137 8.86969C8.07317 8.86969 7.72738 9.09272 7.55145 9.42061C7.37553 9.09277 7.02973 8.86969 6.63153 8.86969C6.05525 8.86969 5.58805 9.3368 5.58805 9.91317C5.58805 10.1034 5.6398 10.2813 5.72877 10.4348H4.17383C4.17383 11.0111 4.67581 11.4783 5.25205 11.4783H5.21731C5.21731 12.0546 5.68447 12.5218 6.2608 12.5218C6.2608 13.032 6.62727 13.456 7.11125 13.5467L6.28906 15.4031C6.68309 15.5633 7.11369 15.6522 7.56519 15.6522C8.01669 15.6522 8.44728 15.5633 8.84131 15.4031L8.01913 13.5467C8.50311 13.4561 8.86958 13.0321 8.86958 12.5218C9.44591 12.5218 9.91306 12.0546 9.91306 11.4783H9.87833C10.4545 11.4783 10.9565 11.0111 10.9565 10.4348Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_34095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/47e0119d.svg";
export { SvgSerbia as ReactComponent };